import { render, staticRenderFns } from "./dnzt.vue?vue&type=template&id=4b627501&scoped=true"
var script = {}
import style0 from "./dnzt.vue?vue&type=style&index=0&id=4b627501&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b627501",
  null
  
)

export default component.exports